export default __webpack_public_path__ + "22a961be5f63fc1d0594ecde05363dc2.woff";